import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ErrorStore } from "../interfaces/error-store.interface";

export const errorStateSelector = createFeatureSelector<ErrorStore>('error');
export const errorPopupIsOpenSelector = createSelector(errorStateSelector, (state: ErrorStore) => state.errorPopupIsOpen);
